var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDokBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 24,
    viewBox: "0 0 78 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1207_283)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.902 0H0V24H10.902C17.5699 24 22.9763 18.6268 22.9763 12C22.9763 5.3732 17.5699 0 10.902 0ZM12.1915 13.2816H9.61255V10.7184H12.1915V13.2816Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6914 0.466797C30.1525 0.466797 24.8516 5.73515 24.8516 12.2338C24.8516 18.7324 30.1525 24.0008 36.6914 24.0008C43.2303 24.0008 48.5313 18.7324 48.5313 12.2338C48.5313 5.73515 43.2303 0.466797 36.6914 0.466797ZM37.9809 13.5153H35.4019V10.9522H37.9809V13.5153Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6504 0.466797V24.0008H62.0706V15.8454H63.067L66.5111 24.0008H77.9993L73.0664 12.2338L77.9993 0.466797H66.422L62.9498 8.50563H62.012V0.466797H50.6504Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1207_283"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 78,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDokBlack);
export default __webpack_public_path__ + "static/media/Dok-black.373ea10447360dbcdbdcdc7f922c9b5a.svg";
export { ForwardRef as ReactComponent };